import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
  fetchTeacherCreatedBlocks,
  fetchCalendarCreatedBlocks,
  createTeacherBlock,
  updateTeacherBlock,
  deleteTeacherBlock
} from 'actions/Teacher/availabilityActions';

import BlockInputs from './BlockInputs';
import BlockTable from './BlockTable';

import './style.css';

const BLOCKED_TIMES_MODE = {
  CALENDAR: 'calendar',
  USER: 'user'
};

class SpecificAvailability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBlockId: null,
      mode: BLOCKED_TIMES_MODE.USER
    };
  }

  componentDidMount() {
    if (this.props.teacher.id) {
      this.fetchBlocks();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.teacher.id && prevProps.teacher.id !== this.props.teacher.id) {
      this.fetchBlocks();
    }
    // if (this.props.createdBlockId && prevProps.createdBlockId !== this.props.createdBlockId) {
    //   this.setState({ selectedBlockId: this.props.createdBlockId });
    // }
  }

  handleBlockedTimeMode = (mode) => {
    return () => {
      this.setState({ mode });
    };
  }

  fetchBlocks = () => {
    this.props.fetchTeacherCreatedBlocks();
    this.props.fetchCalendarCreatedBlocks();
  }

  handleDelete = (blockId) => {
    this.props.deleteTeacherBlock(blockId);
  }

  handleSelect = (block) => {
    this.setState({
      selectedBlockId: block.id
    });
  }

  handleSave = (blockId, blockData) => {
    if (blockId) {
      this.props.updateTeacherBlock(blockId, blockData);
    } else {
      let startTime;
      let endTime;
      if (blockData.allDay) {
        startTime = blockData.startDate.startOf('Day');
        endTime = blockData.endDate.startOf('Day').add(1, 'days');
      } else {
        startTime = blockData.startDate.startOf('Day').add(blockData.startTime, 'minutes');
        endTime = blockData.endDate.startOf('Day').add(blockData.endTime, 'minutes');
      }
      this.props.createTeacherBlock({
        startTime,
        endTime,
        reason: blockData.reason
      });
    }
  }

  handleClear = () => {
    this.setState({
      selectedBlockId: null
    });
  }

  render() {
    const { selectedBlockId } = this.state;
    const {
      teacherCreatedBlocks,
      calendarCreatedBlocks,
      createOrUpdateError,
      createBlockStatus,
      updateBlockStatus
    } = this.props;
    const { mode } = this.state;

    const blocks =
      mode === BLOCKED_TIMES_MODE.CALENDAR ? calendarCreatedBlocks : teacherCreatedBlocks;
    const selectedBlock = blocks.find(block => block.id === selectedBlockId);

    return (
      <div className="specific-availability px-4 px-lg-5 py-4">
        <div className="row">
          <div className="specific-availability__section col-12 col-lg-5">
            <div className="specific-availability__header">
              <p className="specific-availability__header-title">Block specific dates and times</p>
              <p className="specific-availability__header-desc">
                Choose specific dates and times that you’d like to block off in the future for
                vacation, work, important events, etc.
              </p>
            </div>
            <BlockInputs
              selectedBlock={selectedBlock}
              onSave={this.handleSave}
              onClear={this.handleClear}
              createBlockStatus={createBlockStatus}
              updateBlockStatus={updateBlockStatus}
              createOrUpdateError={createOrUpdateError}
            />
          </div>

          <div className="specific-availability__section col-12 col-lg-7">
            <div className="d-flex align-items-center justify-content-start justify-content-lg-end mb-1">
              <div className="btn-group" role="group" aria-label="calendar-mode">
                <button
                  type="button"
                  className={classnames('ongoing-availability__mode btn btn-secondary btn-cursor', {
                    selected: mode === BLOCKED_TIMES_MODE.USER
                  })}
                  onClick={this.handleBlockedTimeMode(BLOCKED_TIMES_MODE.USER)}
                >
                  User
                </button>
                <button
                  type="button"
                  className={classnames('ongoing-availability__mode btn btn-secondary btn-cursor', {
                    selected: mode === BLOCKED_TIMES_MODE.CALENDAR
                  })}
                  onClick={this.handleBlockedTimeMode(BLOCKED_TIMES_MODE.CALENDAR)}
                >
                  Calendar
                </button>
              </div>
            </div>
            <div className="card">
              <BlockTable
                blocks={blocks}
                onDelete={this.handleDelete}
                onSelect={this.handleSelect}
                selectedBlockId={selectedBlockId}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    teacher: state.user.profile,
    teacherCreatedBlocks: state.teacher.teacherCreatedBlocks,
    calendarCreatedBlocks: state.teacher.calendarCreatedBlocks,
    createOrUpdateError: state.teacher.blockError,
    getBlockStatus: state.teacher.getBlockStatus,
    createBlockStatus: state.teacher.createBlockStatus,
    updateBlockStatus: state.teacher.updateBlockStatus,
    deleteBlockStatus: state.teacher.deleteBlockStatus,
    createdBlockId: state.teacher.createdBlockId
  };
}

export default connect(
  mapStateToProps,
  {
    fetchTeacherCreatedBlocks,
    fetchCalendarCreatedBlocks,
    createTeacherBlock,
    updateTeacherBlock,
    deleteTeacherBlock
  }
)(SpecificAvailability);



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Availability/Specific/index.js